import * as React from "react";

import { Card, Divider, Typography } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import axiosInstance from "../utils/axiosInstance";
import { formatCustomDateTime } from "../utils/formatters";
import { useNavigate } from "react-router-dom";

export default function RecentSupportRequests() {
  const [recentSupportRequests, setRecentSupportRequests] = React.useState([]);

  const navigate = useNavigate();

  const fetchRecentSupportRequests = React.useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/support/latest`,
      );

      if (response.status === 200) {
        setRecentSupportRequests(response.data);
      }
    } catch (error) {}
  }, []);

  React.useEffect(() => {
    fetchRecentSupportRequests();
  }, [fetchRecentSupportRequests]);

  return (
    <Card
      variant="outlined"
      sx={{ display: "flex", flexDirection: "column", gap: "8px", flexGrow: 1 }}
    >
      <CardContent>
        <Typography component="h2" variant="subtitle2" gutterBottom>
          Recent Support
        </Typography>

        {recentSupportRequests && recentSupportRequests.length > 0 ? (
          recentSupportRequests.map((request, index) => (
            <React.Fragment key={request.id}>
              <Typography
                variant="body2"
                sx={{
                  cursor: "pointer",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
                onClick={() => navigate("/supports")}
              >
                <strong>{request.title}</strong> -{" "}
                {request.description.slice(0, 150)}...
              </Typography>

              <Typography variant="body2">
                {formatCustomDateTime(request.created_at)}
              </Typography>
              {index !== recentSupportRequests.length - 1 && <Divider sx={{marginY: 1.5}} />}
            </React.Fragment>
          ))
        ) : (
          <Typography>There are no latest support requests.</Typography>
        )}
      </CardContent>
    </Card>
  );
}
